<template>
  <div class="">
    <div class="overlay" v-if="Literacy"></div>
    <div class="head-card">
      <div class="float-right">
        <router-link to="profile"><img src="@/assets/user.png" height="25" width="25" alt="Logo"
            style="float: right"></router-link>
      </div>
      <div class="account_balance">
        <p class="secondary">Total Balance</p>
        <p class="balance cabin-family semi-bold">₦ {{ Number(balance).toLocaleString() }}</p>
        <!-- eslint-disable-next-line max-len -->
        <!-- <button class="btn withdrawal-btn" v-if="userType != 'smart-academy'" @click="openWithdrawal">Withdraw</button> -->
        <button class="btn withdrawal-btn" @click="openWithdrawal">Withdraw</button>
      </div>

      <div class="action-cards" v-if="userType != 'smart-academy' || userType != 'smart-general'">
        <!-- <div class="action-card">
          <img src="@/assets/invested.png" height="30" width="30" alt="Logo">
          <div class="text-left ml-2">
            <p class="secondary fnt-10 mb-0 lh-12">Amount Saved</p>
            <p class="cabin-family bold mb-0">₦ {{ Number(invested).toLocaleString() }}.00</p>
          </div>
        </div>
        <div class="action-card">
          <img src="@/assets/returns.png" height="30" width="30" alt="Logo">
          <div class="text-left ml-2">
            <p class="secondary fnt-10 mb-0 lh-12">Portfolio value</p>
            <p class="cabin-family bold mb-0">₦ {{ Number(roi).toLocaleString() }}.00</p>
          </div>
        </div> -->
      </div>
      <button class="btn primary-btn btn-block" @click="fund">Fund Wallet</button>
    </div>
    <div class="content" v-if="userType === 'smart-steward' || userType === 'mastermind'">
      <h4>Featured Video</h4>
      <!-- <div class="feeds-card" v-if="banner.status === 'active' "> -->
      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/${videoId}`"></iframe>
      <!-- </div> -->

      <h4 style="margin-top: 8px;">Before you start Investing...</h4>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1625752600/SMART_STEWARDS-_CODE_OF_CONDUCT_FOR_CLUB_MEMBERS_ehcemi.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Stewards - Code of Conduct</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1656584747/SIC_Members_NOK_fillable_form_bo94m9.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Investment Club Next of Kin/Investment Form</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1656584747/THE_UPDATED_SMART_INVESTMENT_CLUB_CUSTOMER_JOURNEY_MAP_pscifu.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Investment Club Customer Journey Map</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <div class="links-card-section" @click="openLiteracy">
          <div class="first-col">
            <img src="@/assets/literacy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Risk Profile Assessment</p>
            <p class="sub-text">Fill out this questionnaire to know your risk profile</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>
      </div>

      <h4>Savings</h4>
      <div class="links-card-section inv" @click="openSavingsChallenge(7)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Smart stewards summit 2024 savings challenge</p>
          <p class="sub-text">Save towards the 2024 smart stewards summit</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <!-- <div class="links-card-section inv" @click="lockFunds">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Safelock</p>
          <p class="sub-text">Lock wallet funds to accrue interests</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->
      <!-- <div class="links-card-section inv" @click="openSavingsChallenge(1)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦750,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦750,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->
      <!-- <div class="links-card-section inv" @click="openSavingsChallenge(2)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦1,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦1,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->
      <!-- <div class="links-card-section inv" @click="openSavingsChallenge(3)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦5,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦5,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->
      <!-- <div class="links-card-section inv" @click="openSavingsChallenge(4)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦10,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦10,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->

      <h4>Investments</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openInvestments" v-if="userType !== 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/investments.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Investments</p>
          <p class="sub-text">View all investments on Smart Stewards</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openAngelInvesting" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/investment.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Angel Investing</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <!-- <h4>Networth</h4>
      <div class="links-card-section inv" @click="openNetworth">
        <div class="first-col">
          <img src="@/assets/investment.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Networth</p>
          <p class="sub-text">Click here to calculate your networth </p>
        </div>
        <div class="third-col">
        <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div> -->
      <h4>Cooperative</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openCooperative" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/cooperation.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">SIC Cooperative</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Links</h4>
      <div class="links-card">
        <div class="links-card-section" @click="toggle(4)">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Your Unique Referral Link</p>
            <p class="sub-text">Invite Your Friends and Get Paid</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv4" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv4">
          <div class="text-center" @click="copyText()">
            <p class="cabin-family secondary bold fnt-16">
              {{ referralLink }}</p>
            <p class="copy-text cabin-family">Click to copy.</p>
          </div>
        </div>
      </div>
      <div class="links-card">
        <div class="links-card-section" @click="toggle(1)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">United Capital Funds</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv1" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv1">
          <ol>
            <li><a href="https://investnow.ng/signup/AM_EURO/OREA23" target="_blank">Nigerian Eurobond
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
            <li><a href="https://investnow.ng/signup/AM/OREA23" target="_blank">Money Market
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
            <li><a href="https://investnow.ng/signup/AM_BON/OREA23" target="_blank">Fixed Income Fund
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
          </ol>
        </div>

        <div class="links-card-section" @click="toggle(2)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Buy US Stocks</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv2" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv2">
          <ol>
            <li><a href=" https://app.investbamboo.com/invite/adesola259133" target="_blank">Bamboo ( Buy from Nigeria)
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
          </ol>
        </div>
        <div class="links-card-section" @click="toggle(3)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Register your US business through Smart Stewards</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv3" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv3">
          <ol>
            <li>Get your US Bank Account</li>
            <li>US Phone number / address </li>
            <li>Get customized support </li>
            <li>File Your Taxes </li>
            <a href="https://smartstewards.com/us-business/" target="_blank">https://smartstewards.com/us-business/
            </a>
          </ol>
        </div>
        <div class="links-card-section" @click="smartAcademy">
          <div class="first-col">
            <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Smart Stewards Academy</p>
            <p class="sub-text">Visit our academy to get content to help you boost your
              financial literacy</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>
      </div>

      <div class="transactions" v-if="transactions.length > 0">
        <h4>Transactions</h4>
        <div class="trans-table">
          <!-- eslint-disable-next-line max-len -->
          <div class="trans-table-row" v-for="(trans, ind) in transactions.slice().reverse()" :key="ind">
            <div class="row1">
              <p class="p1">{{ trans.description }}</p>
              <p class="p2">{{ trans.createdAt | formatDate }}</p>
            </div>
            <div class="row2">
              <p>₦{{ Number(trans.amount).toLocaleString() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="userType === 'smart-academy'">
      <h4>Savings</h4>
      <div class="links-card-section inv" @click="lockFunds">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Safelock</p>
          <p class="sub-text">Lock wallet funds to accrue interests</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(7)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Smart stewards summit 2024 savings challenge</p>
          <p class="sub-text">Save towards the 2024 smart stewards summit</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(1)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦750,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦750,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(2)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦1,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦1,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(3)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦5,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦5,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(4)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦10,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦10,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Cooperative</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openCooperative" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/cooperation.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">SIC Cooperative</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
    </div>
    <div class="content" v-if="userType === 'smart-general'">
      <p><span class="bold">Welcome To Smart Stewards:</span> One of Nigeria's Leading Financial
        Literacy Organizations, helping Africans at home and in the diaspora to build wealth</p>
      <p class="bold mt-3">How to save. </p>
      <p>Step 1: Fund your wallet</p>
      <p>Step 2: Get a virtual bank account no</p>
      <p>Step 3 : Make a transfer</p>
      <p>Step 4: Click the link below to save.</p>
      <h4 class="text-left mt-3">Savings</h4>
      <div class="links-card-section inv" @click="smartAcademy">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Join The Smart Stewards Academy Today
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSmartStewards">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Read More About Smart Stewards
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/uyDoNfmvH98`"></iframe>

      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/HcX8YYotbj8`"></iframe>

      <h4>Savings</h4>
      <div class="links-card-section inv" @click="openSavingsChallenge(7)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Smart stewards summit 2024 savings challenge</p>
          <p class="sub-text">Save towards the 2024 smart stewards summit</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

    </div>
    <bank @close="closeLiteracy" v-if="!userBank"></bank>
    <literacy-component @close="closeLiteracy" v-if="Literacy"></literacy-component>
  </div>
</template>

<script>
import LiteracyComponent from './Literacy.vue';
import Bank from '../components/Bank.vue';

export default {
  components: {
    LiteracyComponent,
    Bank,
  },
  data() {
    return {
      Literacy: false,
      showDiv1: false,
      showDiv2: false,
      showDiv3: false,
      showDiv4: false,
      risk_appetite: '',
      transactions: {},
      balance: 0,
      roi: 0,
      userBank: 'active',
      invested: 0,
      banner: {},
      referralCode: '',
      lastname: '',
      userType: '',
      userCooperative: '',
      videoId: '',
      userInvestments: [],
      showInvestmentNotice: false,
    };
  },
  computed: {
    referralLink() {
      return `https://smartstewards-app.netlify.app/signup?referral=${this.referralCode}`;
    },
  },
  created() {
    this.getWallet();
    this.risk_appetite = localStorage.getItem('risk_appetite');
    const user = JSON.parse(localStorage.getItem('user'));
    this.lastname = user.lastname;
    this.referralCode = user.referral_code;
    this.userType = user.user_type;
    this.userCooperative = !!user.cooperative;
    const investmentPop = localStorage.getItem('investment-pop');
    if (!investmentPop) {
      this.showInvestmentNotice = true;
      localStorage.setItem('investment-pop', 'Investment pop up');
    }
  },
  methods: {
    async getWallet() {
      const url = `${this.$baseUrl}/wallet`;
      const res = await this.$http({ url, method: 'GET' });
      this.transactions = res.data.transactions;
      this.userInvestments = res.data.userInvestments;
      this.balance = res.data.balance || 0;
      this.roi = res.data.roi || 0;
      this.invested = res.data.invested || 0;
      const banner = res.data.banner || {};
      const [a, videoId] = banner.image_url.split('=');
      console.log(a);
      this.videoId = videoId;
      this.userBank = res.data.userBankActive;
      localStorage.setItem('balance', this.balance);
    },
    fund() {
      this.$router.push('fund');
    },
    investments() {
      this.$router.push('investments');
    },
    profile() {
      this.$router.push('profile');
    },
    openInvestments() {
      this.$router.push('/investments');
    },
    openCooperative() {
      this.$router.push('/cooperative');
    },
    openCooperativeResources() {
      this.$router.push('/cooperative-resources');
    },
    openAngelInvesting() {
      this.$router.push('/angel-investment');
    },
    openWithdrawal() {
      this.$router.push('/withdrawals');
    },
    lockFunds() {
      this.$router.push('/savings');
    },
    openSavings(plan) {
      this.$router.push(`/savings/${plan}/plan`);
    },
    openSavingsChallenge(plan) {
      this.$router.push(`/savings/${plan}/challenge`);
    },
    targetSavings() {
      this.$router.push('/target-savings');
    },
    openNetworth() {
      this.$router.push('/net-worth');
    },
    openYoutube(link) {
      window.open(link, '_blank');
    },
    smartAcademy() {
      window.open('https://academy.smartstewards.com/bundles/smart-stewards-short-money-courses', '_blank');
    },
    smartAcademy2() {
      window.open('https://academy.smartstewards.com', '_blank');
    },
    openSmartStewards() {
      window.open('https://smartstewards.com/', '_blank');
    },
    smartResources() {
      window.open('https://thesmartinvestmentclub.com/sic-resources/', '_blank');
    },
    smartCourses() {
      window.open('https://thesmartinvestmentclub.com/courses/sicintroductorycourse/', '_blank');
    },
    openLiteracy() {
      this.Literacy = true;
    },
    closeLiteracy() {
      this.Literacy = false;
      this.userBank = true;
      this.risk_appetite = localStorage.getItem('risk_appetite');
    },
    closeModal() {
      this.showInvestmentNotice = false;
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.referralLink);
        this.$toast.open('Copied to clipboard', {
          duration: 2500,
          type: 'success',
          dismissible: true,
        });
      } catch ($e) {
        console.log($e);
      }
    },
    toggle(id) {
      if (id === 1) {
        if (this.showDiv1) {
          this.showDiv1 = false;
        } else {
          this.showDiv1 = true;
        }
      } else if (id === 2) {
        if (this.showDiv2) {
          this.showDiv2 = false;
        } else {
          this.showDiv2 = true;
        }
      } else if (id === 3) {
        if (this.showDiv3) {
          this.showDiv3 = false;
        } else {
          this.showDiv3 = true;
        }
      } else if (id === 4) {
        if (this.showDiv4) {
          this.showDiv4 = false;
        } else {
          this.showDiv4 = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #EE0E4C;
  font-weight: 400;
  font-family: 'Cabin', sans-serif;
  text-decoration: none;
}

li {
  font-family: 'Cabin', sans-serif;

  img {
    margin-left: .25rem;
  }
}

.overlay {
  min-height: 100vh;
  width: 100%;
  background-color: #F9F9F9;
  position: fixed;
  top: 0;
}

p {
  margin-bottom: .25rem;
}

.balance {
  font-size: 32px;
  font-weight: 700;
  line-height: 35px;
  margin-bottom: 0;
}

.head-card {
  background-color: #FFF;
  padding: 2rem;
  border-radius: 0px 0px 25px 25px;
  text-align: center;

  .account_balance {
    margin: 2rem 0;
  }
}

.action-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  .action-card {
    padding: 1rem .35rem;
    width: 47%;
    background-color: #FCFCFC;
    color: #000;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }
}

.trans-table {
  padding: 1rem;
  border-radius: 8px;
  background-color: #FFF;

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .45rem 0;
    border-bottom: 1px solid #E5E5E5;

    &:last-child {
      border-bottom: none;
    }
  }

  .row1 {
    display: flex;
    flex-direction: column;

    .p1 {
      font-size: 12px;
      line-height: 14px;
      font-family: 'Cabin', sans-serif;
    }

    .p2 {
      font-size: 8px;
      line-height: 12px;
      color: #49566A;
      font-family: 'Roboto', sans-serif;
    }
  }

  .row2 {
    p {
      font-family: 'Cabin', sans-serif;
      font-weight: 600;
    }
  }
}

.transactions {
  margin-top: 2rem;
}

.withdrawal-btn {
  font-family: 'Cabin', sans-serif;
  color: #FFF;
  background-color: #EE0E4C;
  border-color: #EE0E4C;
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-weight: 700;
  margin-top: .5rem;
}

.copy-text {
  font-size: 12px;
  color: #50A948;
  margin-bottom: 0;
}
</style>
